
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/articles",
      function () {
        return require("private-next-pages/ranking/articles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/articles"])
      });
    }
  